import { Injectable } from 'angular2/core';
import { Response } from 'angular2/http';
import { Observable } from 'rxjs/Observable';

import { Resource } from '../api/resource.service';

interface UserAuth {
  username: string;
  password: string;
}

@Injectable()
export class UserService {

  constructor(private resource: Resource) { }

  signup(data: UserAuth): Observable<Response> {
    return this.postAuth('/users/register', data);
  }

  login(data: UserAuth): Observable<Response> {
    return this.postAuth('/users/sessions', data);
  }

  logout() {
    localStorage.removeItem('jwt');
  }

  private postAuth(url: string, data: UserAuth): Observable<Response> {
    return this.resource.http.noAuth().post(
      url, JSON.stringify(data)
    );
  }

}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./src/user/user.service.ts
 **/